import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';

export default function TermsPage() {
  const navigate = useNavigate();

  const handleBookingClick = () => {
    navigate('/', { replace: false });
    setTimeout(() => {
      document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-800" style={{ fontFamily: "'Klee One', cursive" }}>
            いまのきもち
          </Link>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">ホーム</Link>
            <Link to="/profile" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">自己紹介</Link>
            <Link to="/terms" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">利用規約</Link>
            <Link to="/faq" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">よくある質問</Link>
          </div>

          <button 
            onClick={handleBookingClick}
            className="bg-[#FF9B8A] hover:bg-[#FF8A77] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            今すぐ予約
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FFF5F3] via-white to-[#F0F9FF]"></div>
        
        <div className="max-w-4xl mx-auto relative z-10 text-center">
          <div className="inline-block px-4 py-2 bg-[#FF9B8A]/10 rounded-full mb-6">
            <span className="text-[#FF9B8A] text-sm font-medium">ご利用前に必ずお読みください</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Klee One', cursive" }}>
            利用規約・注意事項・免責事項
          </h1>
          
          <p className="text-lg text-gray-600">
            安心してご利用いただくために、以下の内容をご確認ください
          </p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          {/* 前文 */}
          <div className="mb-12 bg-gradient-to-br from-[#FF9B8A]/10 to-[#FFD93D]/10 rounded-3xl p-8 border-2 border-[#FF9B8A]/30">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FF9B8A] rounded-full mb-4">
                <i className="ri-file-text-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">利用規約について</h2>
            </div>
            <div className="text-center text-gray-700 leading-relaxed">
              <p className="mb-4">
                本規約は、本サービス（以下「本サービス」）の利用条件および提供条件を定めるものです。
              </p>
              <p className="font-medium text-[#FF9B8A]">
                利用者は、本サービスを利用することにより、本規約の内容に同意したものとみなされます。
              </p>
            </div>
          </div>

          <div className="space-y-8">
            {/* 第1条｜サービスの位置づけ */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border-2 border-gray-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#FF9B8A]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#FF9B8A] font-bold text-lg">第1条</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">サービスの位置づけ</h3>
                  <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
                    <p>本サービスは、日常的な悩みや気持ちの整理を目的とした対話・傾聴を中心とするサポートサービスです。</p>
                    
                    <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4">
                      <p className="font-bold text-red-900 mb-2">本サービスは以下に該当しません</p>
                      <ul className="space-y-1 text-red-800 text-sm">
                        <li>• 医療行為</li>
                        <li>• 診断・治療・処方</li>
                        <li>• 心理療法・精神療法</li>
                        <li>• 専門的カウンセリング</li>
                        <li>• 医療・心理専門職による支援行為</li>
                      </ul>
                    </div>
                    
                    <p className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 text-blue-900">
                      提供者は、医師・臨床心理士・公認心理師等の国家資格は保有しておらず、本サービスは専門的治療の代替となるものではありません。
                    </p>
                    
                    <p className="font-medium bg-green-50 border-2 border-green-200 rounded-xl p-4 text-green-900">
                      本サービスは、<strong>「話すことによる気持ちの整理や安心感の補助」</strong>を目的とするものであり、症状の改善・回復・行動変容・問題解決を保証するものではありません。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 第2条｜サービス内容 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border-2 border-gray-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#A8D5E2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#A8D5E2] font-bold text-lg">第2条</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">サービス内容</h3>
                  <p className="text-gray-700 text-sm mb-4">本サービスでは、以下のような日常的な悩みや気持ちを対象とします。</p>
                  
                  <div className="mb-6">
                    <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4">
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2">
                          <span className="text-[#A8D5E2] mt-1">•</span>
                          <span>恋愛や人間関係に関する悩み</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="text-[#A8D5E2] mt-1">•</span>
                          <span>成長過程における体や心の変化への不安</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="text-[#A8D5E2] mt-1">•</span>
                          <span>食事や体型に関する気持ちのモヤモヤ</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="text-[#A8D5E2] mt-1">•</span>
                          <span>同じ考えが頭から離れないことによる困り感</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="text-[#A8D5E2] mt-1">•</span>
                          <span>親や家族との関係性に関する悩み</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="text-[#A8D5E2] mt-1">•</span>
                          <span>理由のはっきりしない不安や気分の落ち込み</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-4">
                    <p className="font-bold text-yellow-900 mb-2">本サービスでは以下の行為は行いません</p>
                    <ul className="space-y-1 text-yellow-800 text-sm">
                      <li>• 助言・指示・指導</li>
                      <li>• 行動改善の提案</li>
                      <li>• 治療的介入</li>
                      <li>• 診断的判断</li>
                      <li>• 医学的・心理学的評価</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* 第3条｜対応不可事項 */}
            <div className="bg-gradient-to-br from-[#FEF2F2] to-white rounded-2xl p-8 border-2 border-red-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第3条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">対応不可事項</h2>
              </div>
              <div className="ml-16 space-y-4 text-gray-700">
                <p className="leading-relaxed font-medium text-red-700">
                  以下の内容については、本サービスでは対応できません。
                </p>
                
                <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4">
                  <ul className="space-y-2 text-sm text-red-800">
                    <li className="flex items-start gap-2">
                      <span className="mt-1">•</span>
                      <span>医師等から精神疾患の診断を受けている方の相談</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="mt-1">•</span>
                      <span>自傷行為・自殺についての具体的計画や強い衝動がある場合</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="mt-1">•</span>
                      <span>現在進行中の虐待・犯罪行為に関する相談</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="mt-1">•</span>
                      <span>医学的・専門的判断や治療が必要な内容</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="mt-1">•</span>
                      <span>薬物・アルコール依存に関する相談</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="mt-1">•</span>
                      <span>法律的判断・助言を要する内容</span>
                    </li>
                  </ul>
                </div>
                
                <p className="text-sm text-red-700 font-medium mt-4">
                  該当すると判断した場合、サービス提供を中断または拒否することがあります。
                </p>
              </div>
            </div>

            {/* 第4条｜緊急時対応・安全管理 */}
            <div className="bg-gradient-to-br from-orange-50 to-white rounded-2xl p-8 border-2 border-orange-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第4条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">緊急時対応・安全管理</h2>
              </div>
              <div className="ml-16 space-y-4 text-gray-700">
                <p className="leading-relaxed font-medium text-orange-700">
                  セッション中に、利用者ご本人または第三者の生命・身体の安全に重大な危険があると判断した場合、以下の対応を行うことがあります。
                </p>
                
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-orange-700 font-bold text-sm">1</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">セッションの即時中断</h4>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-orange-700 font-bold text-sm">2</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">医療機関・公的支援窓口・専門機関の案内</h4>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-orange-700 font-bold text-sm">3</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">未成年者の場合、保護者・関係機関への連絡</h4>
                    </div>
                  </div>
                </div>

                <div className="mt-4 p-5 bg-orange-50 border border-orange-200 rounded-xl">
                  <p className="text-sm text-orange-900 leading-relaxed font-medium">
                    これらの対応は、守秘義務の例外として行われます。
                  </p>
                </div>

                <div className="mt-4 p-5 bg-orange-50 border border-orange-200 rounded-xl">
                  <h4 className="font-bold text-orange-900 mb-3 flex items-center gap-2">
                    <i className="ri-phone-line text-lg w-5 h-5 flex items-center justify-center"></i>
                    緊急時の相談窓口
                  </h4>
                  <div className="space-y-2 text-sm text-orange-900">
                    <p><strong>いのちの電話：</strong>0120-783-556（24時間対応）</p>
                    <p><strong>東京いのちの電話：</strong>03-3264-4343（24時間対応）</p>
                    <p><strong>こころの健康相談統一ダイヤル：</strong>0570-064-556</p>
                    <p><strong>児童相談所虐待対応ダイヤル：</strong>189（24時間対応）</p>
                    <p><strong>警察：</strong>110（緊急時）</p>
                    <p><strong>救急車：</strong>119（生命の危険がある場合）</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 第5条｜守秘義務 */}
            <div className="bg-gradient-to-br from-[#F5F0FF] to-white rounded-2xl p-8 border border-[#B4A5D5]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#B4A5D5] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第5条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">守秘義務</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  セッション内容および個人情報は原則として第三者に開示されません。
                </p>
                <p className="leading-relaxed font-medium text-gray-900">
                  ただし、以下の場合は例外とします：
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>生命・身体に重大な危険が及ぶ可能性がある場合</li>
                  <li>虐待・犯罪行為が疑われる場合</li>
                  <li>法令に基づく開示義務がある場合</li>
                </ul>
              </div>
            </div>

            {/* 第6条｜未成年者の利用 */}
            <div className="bg-gradient-to-br from-[#FFFBF0] to-white rounded-2xl p-8 border border-[#FFD93D]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#FFD93D] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第6条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">未成年者の利用</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  18歳未満の方が本サービスを利用する場合、保護者の事前同意が必須となります。
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>書面またはオンラインによる同意取得</li>
                  <li>保護者氏名・続柄・連絡先の登録</li>
                  <li>緊急時の保護者連絡体制の確保</li>
                </ul>
                <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
                  <p className="text-sm text-yellow-900 leading-relaxed font-medium">
                    <i className="ri-alert-line text-yellow-700 mr-2"></i>
                    ※ 保護者同意があっても、提供者が不適切と判断した場合、サービス提供をお断りまたは中断することがあります。
                  </p>
                </div>
              </div>
            </div>

            {/* 第7条｜利用者の責任 */}
            <div className="bg-gradient-to-br from-[#F0F9FF] to-white rounded-2xl p-8 border border-[#A8D5E2]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#A8D5E2] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第7条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">利用者の責任</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  本サービスの利用は、利用者自身の判断と責任において行われるものとします。
                </p>
                <p className="leading-relaxed">
                  利用者は、必要に応じて、医療機関・専門機関・公的支援機関を利用する責任を負います。
                </p>
              </div>
            </div>

            {/* 第8条｜責任制限・免責 */}
            <div className="bg-gradient-to-br from-[#FFF5F3] to-white rounded-2xl p-8 border border-[#FF9B8A]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#FF9B8A] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第8条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">責任制限・免責</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="text-[#FF9B8A] mt-1">•</span>
                    <span>本サービスは特定の結果・効果・問題解決を保証しません</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FF9B8A] mt-1">•</span>
                    <span>効果・感じ方には個人差があります</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FF9B8A] mt-1">•</span>
                    <span>セッション内容を利用者が実践した結果について、提供者は一切の責任を負いません</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FF9B8A] mt-1">•</span>
                    <span>提供者は、本サービス利用により生じたいかなる損害についても、法律上認められる範囲において責任を負いません</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 第9条｜決済・返金 */}
            <div className="bg-gradient-to-br from-[#F0F9FF] to-white rounded-2xl p-8 border border-[#A8D5E2]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#A8D5E2] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第9条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">決済・返金</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="text-[#A8D5E2] mt-1">•</span>
                    <span>本サービスは事前決済制です</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#A8D5E2] mt-1">•</span>
                    <span>セッション開始24時間前までのキャンセルは返金可能</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#A8D5E2] mt-1">•</span>
                    <span>24時間前以降のキャンセル、無断キャンセル、セッション開始後の返金は不可</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#A8D5E2] mt-1">•</span>
                    <span>通信環境不良・システム障害等については、状況に応じて個別対応とします</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 第10条｜個人情報の取り扱い */}
            <div className="bg-gradient-to-br from-[#F5F0FF] to-white rounded-2xl p-8 border border-[#B4A5D5]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#B4A5D5] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第10条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">個人情報の取り扱い</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed mb-3">
                  取得した個人情報は以下の目的に限定して使用します：
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                  <li>セッション実施</li>
                  <li>連絡および運営管理</li>
                </ul>
                <p className="leading-relaxed mb-3">
                  第三者提供は行いません（法令に基づく開示を除く）。
                </p>
                <p className="leading-relaxed text-sm text-gray-600">
                  ※ 本サービスでは、Supabase等の海外サーバーを利用する場合があり、データが海外に保管される可能性があります。
                </p>
              </div>
            </div>

            {/* 第11条｜規約の変更 */}
            <div className="bg-gradient-to-br from-[#FFFBF0] to-white rounded-2xl p-8 border border-[#FFD93D]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#FFD93D] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第11条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">規約の変更</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  本規約は、必要に応じて予告なく変更されることがあります。
                </p>
                <p className="leading-relaxed">
                  変更後の規約は、HP上に掲載された時点で効力を持つものとします。
                </p>
              </div>
            </div>

            {/* 第12条｜提供者情報の開示 */}
            <div className="bg-gradient-to-br from-[#F0F9FF] to-white rounded-2xl p-8 border border-[#A8D5E2]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#A8D5E2] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第12条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">提供者情報の開示</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                  <h4 className="font-bold text-blue-900 mb-3">提供者情報</h4>
                  <ul className="space-y-2 text-sm text-blue-800">
                    <li>• 氏名：福井 萌日香</li>
                    <li>• 年齢：22歳</li>
                    <li>• 学歴：心理学専攻の大学生</li>
                    <li>• 保有資格：なし（医療・心理系国家資格未取得）</li>
                    <li>• 経験：学習・研修のみ（臨床経験なし）</li>
                  </ul>
                </div>
                <p className="text-sm text-gray-600">
                  提供者は心理学を学習中の学生であり、医療従事者・心理専門職ではありません。
                </p>
              </div>
            </div>

            {/* 第13条｜継続学習・向上への取り組み */}
            <div className="bg-gradient-to-br from-[#F5F0FF] to-white rounded-2xl p-8 border border-[#B4A5D5]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#B4A5D5] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第13条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">継続学習・向上への取り組み</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  提供者は、より良いサービス提供のため、以下の取り組みを行います：
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="text-[#B4A5D5] mt-1">•</span>
                    <span>心理学・カウンセリング理論の継続学習</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#B4A5D5] mt-1">•</span>
                    <span>倫理・安全管理に関する研修受講</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#B4A5D5] mt-1">•</span>
                    <span>専門家による定期的な監督・指導</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#B4A5D5] mt-1">•</span>
                    <span>サービス品質の定期的な見直し</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 第14条｜セッションの録音・記録について */}
            <div className="bg-gradient-to-br from-[#FFF5F3] to-white rounded-2xl p-8 border border-[#FF9B8A]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#FF9B8A] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第14条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">セッションの録音・記録について</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                  <p className="font-bold text-red-900 mb-2">録音・録画・スクリーンショットの禁止</p>
                  <p className="text-sm text-red-800">
                    セッション中の録音・録画・画面キャプチャ等の記録行為は、双方ともに禁止されています。
                  </p>
                </div>
                <p className="leading-relaxed">
                  提供者は、サービス向上のため簡潔な記録（日時、概要のみ）を作成することがありますが、
                  詳細な会話内容は記録しません。
                </p>
                <p className="leading-relaxed">
                  利用者が録音・記録を希望される場合は、事前にご相談ください。
                </p>
              </div>
            </div>

            {/* 第15条｜サービス中止・変更について */}
            <div className="bg-gradient-to-br from-[#FFFBF0] to-white rounded-2xl p-8 border border-[#FFD93D]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#FFD93D] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第15条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">サービス中止・変更について</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  以下の場合、本サービスを一時的または永続的に中止・変更することがあります：
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD93D] mt-1">•</span>
                    <span>提供者の学習・研究状況の変化</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD93D] mt-1">•</span>
                    <span>法規制・ガイドラインの変更</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD93D] mt-1">•</span>
                    <span>技術的・運営上の理由</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD93D] mt-1">•</span>
                    <span>その他やむを得ない事由</span>
                  </li>
                </ul>
                <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
                  <p className="text-sm text-yellow-900">
                    サービス中止の場合、可能な限り事前にご連絡いたします。
                    既にお支払いいただいた料金については、未実施分を返金いたします。
                  </p>
                </div>
              </div>
            </div>

            {/* 第16条｜準拠法・管轄裁判所 */}
            <div className="bg-gradient-to-br from-[#F0F9FF] to-white rounded-2xl p-8 border border-[#A8D5E2]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#A8D5E2] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第16条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">準拠法・管轄裁判所</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  本規約の解釈・適用については、日本国法を準拠法とします。
                </p>
                <p className="leading-relaxed">
                  本サービスに関する一切の紛争については、
                  提供者の居住地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。
                </p>
              </div>
            </div>

            {/* 第17条｜お問い合わせ窓口 */}
            <div className="bg-gradient-to-br from-[#F5F0FF] to-white rounded-2xl p-8 border border-[#B4A5D5]/20">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-[#B4A5D5] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-lg">第17条</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mt-2">お問い合わせ窓口</h2>
              </div>
              <div className="ml-16 space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  本サービス・本規約に関するお問い合わせは、以下までご連絡ください：
                </p>
                <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                  <p className="text-sm text-purple-900">
                    <strong>サービス名：</strong>いまのきもち<br />
                    <strong>提供者：</strong>福井 萌日香<br />
                    <strong>メール：</strong>予約フォームからお問い合わせください<br />
                    <strong>対応時間：</strong>平日 9:00-18:00（土日祝日除く）
                  </p>
                </div>
                <p className="text-sm text-gray-600">
                  ※ 緊急時や危機的状況については、専門機関（医療機関、警察、児童相談所等）へ直接ご連絡ください。
                </p>
              </div>
            </div>
          </div>

          {/* Important Notice */}
          <div className="mt-16 bg-gradient-to-br from-[#FF9B8A]/10 to-white rounded-3xl p-10 border-2 border-[#FF9B8A]/30">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FF9B8A] rounded-full mb-4">
                <i className="ri-alert-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">重要なお願い</h3>
            </div>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p className="text-center">
                本サービスは、<strong>医療行為・診断・治療・心理療法・精神療法の代替ではありません</strong>。
              </p>
              <p className="text-center">
                心身の不調が続く場合や、深刻な症状がある場合は、<br />
                <strong className="text-[#FF9B8A]">必ず医療機関や専門機関を受診してください</strong>。
              </p>
              <p className="text-center text-sm text-gray-600 mt-6">
                緊急時の相談窓口：<br />
                <strong>いのちの電話</strong> 0120-783-556（24時間対応）<br />
                <strong>東京いのちの電話</strong> 03-3264-4343（24時間対応）<br />
                <strong>こころの健康相談統一ダイヤル</strong> 0570-064-556
              </p>
            </div>
          </div>

          {/* Agreement */}
          <div className="mt-12 text-center">
            <p className="text-gray-700 mb-6">
              本サービスをご利用いただくことで、上記の利用規約・注意事項・免責事項に同意したものとみなします。
            </p>
            <Link 
              to="/consent"
              className="inline-block bg-[#FF9B8A] hover:bg-[#FF8A77] text-white px-10 py-4 rounded-full text-base font-medium transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              同意して予約へ進む
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
